<template>
  <div class="modal-container window">
    <detail-header
        :formDataObj="formData"
        :isSubmit="isSubmit"
        :isEdit="true"
        :pcdType="1"
        @payObj="getPayObj"
        :isLoaded="isLoaded"
        :isHasDo="true"
        :isOrder="isOrder"
        @selectComp="selectCompName"
        :isAcc="isAcc"
    ></detail-header>
    <!--    @isErrMap="getIsErrMap"-->
    <div class="pay-modal-main">
      <table-header
          :isAcc="isAcc"
          @add="insertEvent"
          @remove="removeEvent"
          @copy="copyEvent"
          :batch="true"
          @batchAdd="openBatchAdd"
      ></table-header>
      <!--线下-->
      <div class="add-box clearfix" v-show="payType === 1">
        <vxe-table
            border
            show-overflow
            keep-source
            class="table-style produre"
            max-height="680"
            ref="xTable"
            highlight-hover-row
            :data="tableData"
            :edit-rules="editRules"
            :auto-resize="true"
            :edit-config="{ trigger: 'click', mode: 'row', showIcon: false }"
            @cell-click="cellClickEvent"
            @scroll="$refs.xTable.clearValidate()"
            :show-footer="true"
            :footer-method="footerMethod"
            :footer-cell-class-name="footerCellClassName"
        >
          <vxe-table-column width="50" align="center" type="checkbox"></vxe-table-column>

          <vxe-table-column width="60" align="center" field="index" title="序号" v-if="isImport"></vxe-table-column>
          <vxe-table-column type="seq" width="60" align="center" title="序号" v-else></vxe-table-column>
          <vxe-table-column field="ordersNum" width="150" title="关联订单" align="center">
            <template v-slot="{ row }">
              <div :class="{ 'link-text': canInsert }" @click="openOrderModal(row)">
              <span>
                <em v-if="row.ordersList && row.ordersList.length > 1">查看关联订单</em>
                <em v-else-if="row.ordersList && row.ordersList.length == 1">{{ row.ordersList[0].ordersNum }}</em>
                <em v-else>选择关联订单</em>
              </span>
              </div>
            </template>
          </vxe-table-column>
          <!-- 2020-09-18 新增 所属公司 业务员 客户名称-->
          <vxe-table-column field="salesMan" width="180" title="业务员" align="center">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="scope">
              <div>
                <div v-if="!canInsert || scope.row.isOrderSalesMan">
                  {{ scope.row.salesMan }}
                </div>
                <sales-man v-else :row="scope.row" :field="'salesMan'"></sales-man>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="clientName" width="200" title="客户名称" align="center">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row }">
              <div class="link-text" @click="openChooseAccount(row, 'clientName')" v-if="canInsert">
                {{ row.clientName ? row.clientName : "选择客户" }}
              </div>
              <div v-else>{{ row.clientName }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="moneyType" width="120" title="资金类型" align="center">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row }">
              <vxe-select
                  v-model="row.moneyType"
                  :options="moneyTypeOption"
                  placeholder="请选择"
                  transfer
              ></vxe-select>
            </template>
          </vxe-table-column>
          <!--          <vxe-table-column title="客户手机号" field="clientRegisiterNum" width="200">-->
          <!--            <template v-slot="{ row }">-->
          <!--              <vxe-input v-model="row.clientRegisiterNum" placeholder="选填"></vxe-input>-->
          <!--            </template>-->
          <!--          </vxe-table-column>-->
          <vxe-table-column width="150" field="addTime" title="日期">
            <template v-slot:header="{ column }">
            <span class="column-title"
            >{{ column.title }} <i style="color: #f00"> * </i></span
            >
            </template>
            <template v-slot="{ row }">
              <vxe-input
                  v-model="row.addTime"
                  placeholder="请选择"
                  type="date"
                  :editable="false"
                  :disabled="payType === 0 || isAcc"
                  prefix-icon
                  transfer
              ></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="payAmount" title="金额">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="scope">
              <vxe-input
                  :disabled="isAcc"
                  v-model="scope.row.payAmount"
                  v-on:input="inputPayAmountEvent(scope.row)"
                  @input="$refs.xTable.updateStatus(scope)"
                  placeholder="必填"
                  type="number"
              ></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="note" title="摘要">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row }">
              <vxe-input v-model="row.note" placeholder="必填" maxlength="200"></vxe-input>
<!--              <span v-else>{{ row.note }}</span>-->
            </template>
          </vxe-table-column>

          <!-- 平台跟托运人往来的收款  开始 -->
          <vxe-table-column width="200" field="recName" title="收款账户" class-name="link-text">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row, $rowIndex }">
              <div class="link-text" v-if="!isAcc"
                   @click="openBankAccountModal(row, 'recName', 'platform', $rowIndex)">
                {{ row.recName == null || row.recName == "" || row.recName == "null" ? "选择平台银行账户" : row.recName }}
              </div>
              <div v-else style="color: black;">{{ row.recName }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column width="220" field="recAccount" title="收款账号">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="200" field="recBank" title="收款开户行">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
          </vxe-table-column>

          <vxe-table-column width="200" field="paymentsName" title="对方账户" v-if="cate === 'Collection'">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row, $rowIndex }">
              <vxe-input v-model="row.paymentsName" v-if="!isAcc" placeholder="请输入对方账户">
                <template #suffix>
                  <Icon v-if="!isAcc"
                        style="color: #2d8cf0; font-size: 20px; cursor: pointer"
                        type="ios-list-box-outline"
                        @click="openBankAccountModal(row, 'paymentsName', 'user', $rowIndex)"
                  />
                </template>
              </vxe-input>
              <span v-else>{{ row.paymentsName }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="200" field="payAccount" title="对方帐号">
            <template v-slot="scope">
              <vxe-input
                  v-if="!isAcc"
                  v-model="scope.row.payAccount"
                  @input="$refs.xTable.updateStatus(scope)"
                  placeholder="选填"
              ></vxe-input>
              <span v-else>{{ scope.row.payAccount }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="220" field="payBank" title="对方开户行">
            <template v-slot="scope">
              <vxe-input
                  v-if="!isAcc"
                  v-model="scope.row.payBank"
                  @input="$refs.xTable.updateStatus(scope)"
                  placeholder="选填"
              ></vxe-input>
              <span v-else>{{ scope.row.payBank }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="fileList" title="操作" align="center">
            <template v-slot="{ row }">
              <upload-row :row="row" :initFileList="row.fileList"></upload-row>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="add-box clearfix" v-show="payType === 0">
        <!--线上-->
        <vxe-table
            border
            show-overflow
            keep-source
            class="table-style produre"
            ref="xTable1"
            highlight-hover-row
            max-height="680"
            :data="tableData"
            :edit-rules="editRules"
            :auto-resize="true"
            :edit-config="{ trigger: 'click', mode: 'row', showIcon: false }"
            @cell-click="cellClickEvent"
            @scroll="$refs.xTable1.clearValidate()"
            :show-footer="true"
            :footer-method="footerMethod"
            :footer-cell-class-name="footerCellClassName"
        >
          <vxe-table-column width="50" align="center" type="checkbox"></vxe-table-column>

          <vxe-table-column width="60" align="center" field="index" title="序号" v-if="isImport"></vxe-table-column>
          <vxe-table-column type="seq" width="60" align="center" title="序号" v-else></vxe-table-column>
          <vxe-table-column field="ordersNum" width="150" title="关联订单" align="center">
            <template v-slot="{ row }">
              <div :class="{ 'link-text': canInsert }" @click="openOrderModal(row)">
              <span>
                <em v-if="row.ordersList && row.ordersList.length > 1">查看关联订单</em>
                <em v-else-if="row.ordersList && row.ordersList.length == 1">{{ row.ordersList[0].ordersNum }}</em>
                <em v-else>选择关联订单</em>
              </span>
                <img v-if="row.ordersList && row.ordersList.length == 1"
                     style="height: 10px;width: 10px;cursor: pointer;"
                     src="~assets/images/common/close.png"
                     @click.stop="removeOrder(row)"/>
              </div>
            </template>
          </vxe-table-column>
          <!-- 2020-09-18 新增 所属公司 业务员 客户名称-->
          <vxe-table-column field="salesMan" width="180" title="业务员" align="center">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="scope">
              <div>
                <div v-if="!canInsert || scope.row.isOrderSalesMan">
                  {{ scope.row.salesMan }}
                </div>
                <sales-man v-else :row="scope.row" :field="'salesMan'"></sales-man>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="clientName" width="200" title="客户名称" align="center">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row }">
              <div class="link-text" @click="openChooseAccount(row, 'clientName')" v-if="canInsert">
                {{ row.clientName ? row.clientName : "选择客户" }}
              </div>
              <div v-else>{{ row.clientName }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="moneyType" width="120" title="资金类型" align="center">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row }">
              <vxe-select
                  v-model="row.moneyType"
                  :options="moneyTypeOption"
                  placeholder="请选择"
                  transfer
              ></vxe-select>
            </template>
          </vxe-table-column>
          <!--          <vxe-table-column title="客户手机号" field="clientRegisiterNum" width="200">-->
          <!--            <template v-slot="{ row }">-->
          <!--              <vxe-input v-model="row.clientRegisiterNum" placeholder="选填"></vxe-input>-->
          <!--            </template>-->
          <!--          </vxe-table-column>-->
          <vxe-table-column width="150" field="addTime" title="日期">
            <template v-slot:header="{ column }">
            <span class="column-title"
            >{{ column.title }} <i style="color: #f00"> * </i></span
            >
            </template>
            <template v-slot="{ row }">
              <vxe-input
                  v-model="row.addTime"
                  placeholder="请选择"
                  type="date"
                  :editable="false"
                  :disabled="payType === 0"
                  prefix-icon
                  transfer
              ></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="payAmount" title="金额">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="scope">
              <vxe-input
                  v-model="scope.row.payAmount"
                  v-on:input="inputPayAmountEvent(scope.row)"
                  @input="$refs.xTable1.updateStatus(scope)"
                  placeholder="必填"
                  type="number"
              ></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="note" title="摘要">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row }">
              <vxe-input v-model="row.note" placeholder="必填" maxlength="200"></vxe-input>
            </template>
          </vxe-table-column>

          <!-- 平台跟托运人往来的收款  开始 -->
          <vxe-table-column width="200" field="recName" title="收款账户" class-name="link-text"
                            v-if="cate === 'Collection'">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row, $rowIndex }">
              <div class="link-text" @click="openBankAccountModal(row, 'recName', 'platform', $rowIndex)">
                {{ row.recName == null || row.recName == "" || row.recName == "null" ? "选择平台银行账户" : row.recName }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column width="200" field="recCompName" title="账户所属公司">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="220" field="recAccount" title="收款账号">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
          </vxe-table-column>

          <vxe-table-column width="200" field="paymentsName" title="对方账户">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
            <template v-slot="{ row, $rowIndex }">
              <div class="link-text" @click="openBankAccountModal(row, 'paymentsName', 'user', $rowIndex)">
                {{
                  row.paymentsName == null || row.paymentsName === "" || row.paymentsName === "null" ? "选择用户银行账户" :
                      row.paymentsName
                }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column width="200" field="payCompName" title="账户所属公司">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="220" field="payAccount" title="对方帐号">
            <template v-slot:header="{ column }">
              <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="150" field="fileList" title="操作" align="center">
            <template v-slot="{ row }">
              <upload-row :row="row" :initFileList="row.fileList"></upload-row>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <upload-table ref="uploadTable" class="produre" style="margin-top: 20px;margin-bottom: 50px;" :row="uploadData[0]"
                    :initFileList="fileList"></upload-table>
      <div class="footer-btn">
        <Button type="primary" @click="impotEvent" v-if="isImport || isCurImport">上传导入文件</Button>
        <Button type="primary" @click="submitEvent('new')">提交</Button>
        <Button type="primary" @click="showTempModal" class="left10"
                v-if="isHavePermission('payments:createPaymentsBuyer') &&!isCurImport &&!isImport && !isAcc">批量导入
        </Button>
        <Button type="primary" @click="submitEvent('save')" class="left10" v-if="!isAcc">保存</Button>
      </div>

      <!-- 弹窗 -->
      <!-- 选择关联订单 -->
      <vxe-modal v-model="isShowChooseOrder" width="1300" height="700" resize remember title="选择订单">
        <choose-order :chainId="chainId" @choose="chooseOrderEvent" ref="refPaymentAboutOrder"></choose-order>
      </vxe-modal>

      <!-- 选择企业 -->
      <vxe-modal v-model="isShowChooseAccount" width="800" height="600" resize remember title="选择客户">
        <choose-account @choose="chooseAccountEvent" ref="chooseAccount"></choose-account>
      </vxe-modal>

      <!-- 选择银行账户 -->
      <vxe-modal v-model="isShowBankAccountModal" width="1200" height="600" resize remember
                 :title="bankAccountModalTitle" :showHeader="false">
        <bank-account @close="closeBankAccount" @choose="chooseBankAccount" :isShow="isShowBankAccountModal"
                      ref="bankAccountModal"></bank-account>
      </vxe-modal>
      <vxe-modal v-model="templateVisible" title="款项收入流程导入" width="1000" height="650" @close="closeTemplate" remember>
        <import @goImport="goImport" @close="closeTemplate" ref="modalTemplate"></import>
      </vxe-modal>
      <vxe-modal v-model="isShowOnlineChooseOrder" width="1300" height="700" resize remember title="选择订单">
        <choose-order-online @choose="chooseOrderOnlineEvent" :isOnlyBuyer="true"
                             ref="refPaymentAboutOrderOnline"></choose-order-online>
      </vxe-modal>
      <vxe-modal v-model="isShowFinance" width="800" height="600" resize remember title="选择子账户">
        <finance-account @choose="chooseFinanceAccount" ref="financeAccount"></finance-account>
      </vxe-modal>
      <vxe-modal v-model="batchModal" width="500" height="200" resize remember title="批量填写">
        <batch-add ref="batchAddModal" @batchAdd="batchAdd" @close="batchModal = false"></batch-add>
      </vxe-modal>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import $api from "@/apiProvider";
import UploadList from "@/components/common/UploadList";
import Account from "@/components/modal/Account";
import BankAccount from "@/components/proceduremodal/BankAccount";
import {
  getExcelTime,
  hideLoading,
  isEmpty,
  isNotEmpty,
  paymentFooter,
  showFailMsgList,
  showLoading
} from "@/utils/util";
import {timeFormatDate, timeToVal} from "@/filters/time";
import TableHeader from "@/components/common/TableHeader";
import SalesMan from "@/components/common/SalesMan";
import PlatformCorp from "@/components/common/PlatformCorp";
// import CustomerSelect from "@/components/common/CustomerSelect";
import getAuthOrization from "@/mixin/getAuthOrization";
import ChooseOrder from "@/components/proceduremodal/CollectionOrder";
import DetailHeader from "@/views/procedure/DetailHeaderTwo";
import Import from "@/components/common/Import"; // 导入
import ChooseOrderOnline from "@/components/proceduremodal/PayAboutOrder";
import FinanceAccount from "@/components/modal/FinanceAccount";
import {apiRequest} from "@/utils/api";
import BatchAdd from "@/components/proceduremodal/BatchAdd";
import UploadRow from "@/components/modal/UploadRow";
import UploadTable from "@/components/modal/UploadTable";
import {getMoneyTypeModel} from "@/apiProvider/other";

const assign = o => Object.assign({}, o);

export default {
  mixins: [getAuthOrization],
  name: "CreateCollection",
  components: {
    // CustomerSelect,
    SalesMan,
    TableHeader,
    ChooseOrder,
    UploadRow,
    BankAccount,
    ChooseAccount: Account,
    DetailHeader,
    Import,
    ChooseOrderOnline,
    FinanceAccount,
    BatchAdd,
    UploadTable
  },
  props: {
    cate: {
      type: String,
      default: "Collection"
    },
    // isShow: {
    //   type: Boolean,
    //   default: false
    // },
    isImport: {
      type: Boolean,
      default: false
    },
    chainId: {
      type: Number
    }
  },
  data() {
    return {
      isShow: false,
      batchModal: false,
      canInsert: true,
      isShowChooseOrder: false,
      isShowOnlineChooseOrder: false,
      //选择银行账户
      isShowBankAccountModal: false,
      bankAccountModalTitle: "选择银行账户",
      isShowChooseAccount: false, // 选择客户
      amountListName: "ordersList", //关联订单的字段名
      dataTmp: {
        index: "",
        ordersNum: null,
        ordersList: [],
        salesMan: "",
        clientName: "",
        compName: "",
        addTime: "",
        fileUuidList: [],
        fileList: [],
        note: null,
        payAccount: null,
        payAmount: "",
        payBank: null,
        payBankCode: null,
        paymentsName: null,
        recAccount: null,
        recBank: null,
        recName: null,
        unusedAmount: 0,
        usedAmount: 0,
        isOrderCompName: false,
        isOrdersalesMan: false,
        isOrderClientName: false,
        clientRegisiterNum: null,
      },
      tableData: [],
      editRules: {
        salesMan: [{validator: this.requireValid}],
        clientName: [{validator: this.requireValid}],
        compName: [{validator: this.requireValid}],
        payAmount: [{validator: this.requireValid}],
        addTime: [{validator: this.requireValid}],
        note: [{validator: this.requireValid}],
        paymentsName: [{validator: this.requireValid}],
        recName: [{validator: this.requireValid}],
        recBank: [{validator: this.requireValid}],
        recAccount: [{validator: this.requireValid}],
        moneyType: [{validator: this.requireValid}]
      },
      platformCompMap: null,
      flowTempletId: 6,
      formData: {},
      isSubmit: false,
      isErrMap: true,
      isLoaded: false,
      isCurImport: false,
      templateVisible: false,
      isinitByOrder: false,
      uploadData: [
        {
          fileList: null
        }
      ],
      payType: 1,
      isShowFinance: false,
      fromOrigin: "cate",
      orderInfo: null,
      isInitByOrder: null,
      isInitBySave: false,
      fileList: null,
      initBySaveId: null,
      checkboxRecords: [],
      isOrder: false,
      isAcc: false,
      accData: {},
      moneyTypeOption: [],
    };
  },
  watch: {
    isShow: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val == false && oldVal == true) {
          if (isNotEmpty(this.$refs[this.tableName])) {
            this.$refs[this.tableName].clearValidate();
            this.updateFooterEvent();
          }
          this.payType = 1;
          this.tableData = [];
          this.uploadData = [];
          let fileObj = {
            fileList: null
          };
          this.uploadData.push(fileObj);
          this.$refs.uploadTable.init();
          this.canInsert = true;
          this.isSubmit = false;
          this.isLoaded = false;
          this.isCurImport = false;
          this.isinitByOrder = false;
        }
        if (val == true && !this.isInitBySave) {
          this.insertEvent();
          this.getFlowData();
        }
      }
    },
    payType: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val !== oldVal && oldVal !== undefined) {
          this.changeType();
        }
      }
    }
  },
  computed: {
    tableName() {
      return this.payType === 1 ? "xTable" : "xTable1";
    },
  },
  mounted() {
    this.getDicMoneyType();
    this.isShow = true;
    if (this.$route.params.flowId) {
      this.initBySave(this.$route.params.flowId);
    }
    if (this.$route.params.isOrder) {
      this.isOrder = true;
      this.payType = 1;
      let detailData = JSON.parse(localStorage.getItem('detailData'))
      this.initByOrderInfo(detailData);
    }
    if (this.$route.params.isAcc) {
      this.isAcc = true;
      this.payType = 1;
      let accData = JSON.parse(localStorage.getItem('accDetail'));
      this.accData = accData;
      this.initByAcc(accData);
    }
  },
  methods: {
    getDicMoneyType() {
      this.moneyTypeOption = [];
      $api.other.getMoneyTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: item.dictCode,
              };
              this.moneyTypeOption.push(obj);
            });
          });
    },
    initByAcc(accData) {
      this.insertEvent();
      this.currentRow = this.$refs[this.tableName].getTableData().tableData[0];
      this.currentRow.addTime = timeFormatDate(accData.procTimestamp);
      this.currentRow.payAmount = accData.tradeAmount;
      this.currentRow.note = accData.note;

      this.currentRow.paymentsName = accData.payName;
      this.currentRow.payAccount = accData.payAccount;
      this.currentRow.payBank = accData.payBank;

      this.currentRow.recName = accData.recName;
      this.currentRow.recAccount = accData.recAccount;
      this.currentRow.recBank = accData.recBank;

      this.compName = accData.memName;
      this.currentRow.compName = accData.memName;
      this.currentRow.clientName = accData.otherName;
      this.currentRow.clientId = accData.otherSubjectId;
      this.currentRow.payBankCode = accData.fcsSerialNum;
      this.$refs[this.tableName].reloadData([this.currentRow]);
    },
    batchAdd(data) {
      this.checkboxRecords.map(i => {
        i.salesMan = data.name;
        i.salesManId = data.id;
      })
      this.batchModal = false;
      this.$refs[this.tableName].clearValidate();
    },
    openBatchAdd() {
      let checkboxRecords = this.$refs[this.tableName].getCheckboxRecords();
      this.checkboxRecords = checkboxRecords;
      if (isEmpty(checkboxRecords)) {
        this.$XModal.alert({
          message: '至少勾选一条记录',
          status: "error",
        });
        return;
      }
      this.batchModal = true;
      this.$nextTick(() => {
        this.$refs.batchAddModal.init();
      })
    },
    getFlowData() {
      // 获取新建流程信息
      let obj = {
        flowTempletId: this.flowTempletId
      };
      $api.flowInstance.createFlowModel
          .GET({
            params: obj
          })
          .then(res => {
            if (res.status === 1) {
              this.formData = res.data;
              document.title = res.data.instanceName;
              if (this.isOrder) {
                this.$set(this.formData, 'compName', this.orderInfo.compName);
              }
              if (this.isAcc) {
                this.$set(this.formData, 'compName', this.accData.memName);
                this.$set(this.formData, 'payType', 1);
              }
              this.isLoaded = true;
            } else {
              this.$XModal.confirm(res.message).then(() => {
                window.close();
              });
            }
          });
    },
    async initBySave(id) {
      this.isInitBySave = true;
      this.initBySaveId = id;
      $api.flowInstance.queryDraftFlowDetail
          .GET({
            params: {
              id
            }
          })
          .then(res => {
            if (res.status === 1) {
              document.title = res.data.instanceName;
              this.formData = Object.assign(res.data, {
                payType: res.data.payType === 0 ? 1 : 0
              });
              this.isLoaded = true;
              this.fileList = res.data.attachFile;
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error"
              });
            }
          });
      let params = {
        page: 1,
        rows: 10000,
        orderBy: 2,
        isDesc: 0,
        flowId: id
      };
      params.paymentType = 1;
      let resData = await $api.paymentsTwo.request(
          "queryPaymentsListByFlowId",
          params
      );
      if (resData.status == 1) {
        this.tableData = resData.data.rows.map(item => {
          return Object.assign(item, {
            addTime: timeFormatDate(item.addTime)
          });
        });
        if (this.tableData[0]) {
          this.formData.compName = this.tableData[0].compName;
        }
      }
    },
    initByOrderInfo(orderInfo) {
      // 从订单详情页创建流程
      // console.log("创建收付款 通过 订单号初始化 - 开始", orderInfo, this.cate);
      this.orderInfo = orderInfo;
      this.fromOrigin = "order";
      this.isinitByOrder = true;
      this.insertEvent();
      this.currentRow = this.$refs[this.tableName].getTableData().tableData[0];
      this.currentRow.compName = this.orderInfo.compName;
      this.$set(this.formData, 'compName', this.orderInfo.compName);

      if (this.payType === 1) {
        this.chooseOrderEvent([orderInfo], 0);
      } else {
        this.chooseOrderOnlineEvent([orderInfo], 0);
      }

      if (isNotEmpty(orderInfo.platformCompanyId)) {
        this.currentRow.compName = orderInfo.compName;
        this.currentRow.platformCompanyId = orderInfo.platformCompanyId;
      }
      if (isNotEmpty(orderInfo.saleMan)) {
        this.currentRow.salesMan = orderInfo.saleMan;
        this.currentRow.salesManId = orderInfo.saleManId;
      }
      this.$refs[this.tableName].reloadData([this.currentRow]);
      this.canInsert = false;
      // console.log(
      //   "创建收付款 通过 订单号初始化 - 结束",
      //   this.cate,
      //   this.currentRow
      // );
    },
    getPayObj(val) {
      // 获取付款类型
      this.formData = val;
      this.payType = val.type;
    },
    // getIsErrMap(val) {
    //   this.isErrMap = val;
    // },
    insertEvent() {
      // 添加行
      if (isEmpty(this.$refs[this.tableName])) return;
      let tableData = this.$refs[this.tableName].getTableData().tableData;
      this.$refs[this.tableName].clearValidate();
      let record = assign(this.dataTmp);
      record.compName = this.formData.compName;
      record.platformCompanyId = this.platformCompanyId;
      record.recBank = this.account ? this.account.busiSubjectName : null;
      record.recBankOwn = this.account ? this.account.busiSubjectName : null;
      record.recName = this.account ? this.account.memName : null;
      record.recCompName = this.account ? this.account.busiSubjectName : null;
      record.recAccount = this.account ? this.account.subAcc : null;
      if (this.isinitByOrder) {
        //不能新增的情况下 都是复制第一条的
        if (tableData.length > 0) {
          let amountList = [assign(tableData[0][this.amountListName][0])];
          if (this.payType === 1) {
            record = Object.assign(record, {
              ordersNum: tableData[0].ordersNum, //承运人订单号
              ordersId: tableData[0].ordersId,
              salesMan: tableData[0].salesMan,
              salesManId: tableData[0].salesManId,
              compName: tableData[0].compName,
              clientName: tableData[0].clientName,
              clientId: tableData[0].clientId,
              platformCompanyId: tableData[0].platformCompanyId,
              [this.amountListName]: amountList
            });
          } else {
            record = Object.assign(record, {
              ordersNum: tableData[0].ordersNum, //承运人订单号
              ordersId: tableData[0].ordersId,
              salesMan: tableData[0].salesMan,
              salesManId: tableData[0].salesManId,
              compName: tableData[0].compName,
              clientName: tableData[0].clientName,
              clientId: tableData[0].clientId,
              platformCompanyId: tableData[0].platformCompanyId,
              [this.amountListName]: amountList,
              paymentsName: tableData[0].paymentsName,
              payCompName: tableData[0].payCompName,
              payBank: tableData[0].payBank,
              // paymentsName: tableData[0].paymentsName,
              payAccount: tableData[0].payAccount,
              recBank: tableData[0].recBank,
              recName: tableData[0].recName,
              recAccount: tableData[0].recAccount,
              recCompName: tableData[0].recCompName
            });
          }
        }
      }
      record.index = tableData.length + 1;
      record.fileList = [];
      record.fileUuidList = [];
      this.$refs[this.tableName].insertAt(record, -1);
      this.$refs[this.tableName].updateStatus();
      this.updateFooterEvent();
    },
    async removeEvent() {
      // 删除行
      let checkboxRecords = this.$refs[this.tableName].getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择"
        });
        return;
      }
      if (!this.canInsert) {
        //不能全部删除
        if (
            checkboxRecords.length ==
            this.$refs[this.tableName].getTableData().tableData.length
        ) {
          this.$XModal.message({
            message: "不能全部删除,至少保留一条"
          });
          return;
        }
      }
      let confirmRes = await this.$XModal.confirm(
          "删除后不可恢复",
          "是否删除？"
      );
      if (confirmRes == "confirm") {
        this.$refs[this.tableName].removeCheckboxRow();
        this.$refs[this.tableName].updateStatus();
      }
    },
    copyEvent() {
      // 复制行
      let checkboxRecords = this.$refs[this.tableName].getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择"
        });
        return;
      }
      let newRecords = [];
      checkboxRecords.forEach(item => {
        let newItem = assign(item);
        //自主添加收付款的时候不复制关联的订单
        let newAmountList = [];
        if (!this.canInsert) {
          newItem[this.amountListName].forEach(i => {
            newAmountList.push(assign(i));
          });
        } else {
          newItem.ordersNum = "";
        }
        newItem[this.amountListName] = newAmountList;
        newRecords.push(assign(newItem));
      });
      this.$refs[this.tableName].insertAt(newRecords, -1);
      this.$refs[this.tableName].updateStatus();
    },
    cellClickEvent(e) {
      this.$refs[this.tableName].clearValidate();
    },
    changeType() {
      this.account = {};
      this.$refs[this.tableName].remove();
      if (this.fromOrigin === "order") {
        this.initByOrderInfo(this.orderInfo);
      } else {
        this.insertEvent();
      }

      if (this.isAcc) {
        this.initByAcc(this.accData);
      }
    },
    async requireValid(e) {
      if (
          e.columnIndex == 6 &&
          isEmpty(e.row.payAmount) &&
          this.payType === 1
      ) {
        return Promise.reject(new Error("请先填写付款金额"));
      }
      if (
          isNotEmpty(e.row.compName) &&
          e.row.aboutAmount > 0 &&
          e.columnIndex == 2 &&
          this.isImport &&
          isEmpty(e.row.ordersNum)
      ) {
        return Promise.reject(new Error("导入必须填写订单号"));
      }
      if (isEmpty(e.cellValue)) {
        if (
            (e.columnIndex == 2 && !this.isImport) ||
            (e.columnIndex < 5 && !(e.row.payAmount > 0)) ||
            isEmpty(e.row.compName) ||
            (e.column.title == "日期" && this.payType === 0)
        ) {
          console.log("优先验证金额 或者 公司");
        } else {
          return Promise.reject(new Error(e.column.title + "必填"));
        }
      }
    },
    showTempModal() {
      if (isEmpty(this.formData.compName)) {
        this.$XModal.message({status: "error", message: "请先选择所属公司"});
        return
      }
      if (this.payType === 0) {
        this.$refs.modalTemplate.setExport("款项收入流程线上收款导入模板-0628.xls");
      } else {
        this.$refs.modalTemplate.setExport("款项收入流程线下收款导入模板-0628.xls");
      }
      this.templateVisible = true;
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    goImport() {
      // this.isShowCreateInvoice = true;
      // this.isCurImport = true;
      this.impotEvent();
      this.templateVisible = false;
    },
    async impotEvent() {
      await this.initPlatCompMap();
      this.$refs[this.tableName]
          .readFile({
            types: ["xls", "xlsx"]
          })
          .then(evnt => {
            showLoading();
            const tableData = [];
            const files = evnt.target.files;
            const fileReader = new FileReader();
            fileReader.onload = ev => {
              const data = ev.target.result;
              const workbook = XLSX.read(data, {
                type: "binary"
              });
              const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
              // 解析数据
              if (csvData.split("\n").length > 302) {
                hideLoading();
                this.$XModal.alert({
                  message: "本次导入数据超过300条",
                  status: "error",
                });
                return
              }
              csvData.split("\n").forEach((vRow, index) => {
                if (vRow && index > 0) {
                  const vCols = vRow.split(",");
                  let item;
                  let moneyType = null;
                  if (vCols[4]) {
                    this.moneyTypeOption.map(i => {
                      if (i.label === vCols[4]) {
                        moneyType = i.value;
                      }
                    })
                  }
                  if (this.payType === 0) {
                    item = {
                      compName: this.formData.compName,
                      index: vCols[0], //需要
                      ordersList: vCols[1] ? [{ordersNum: vCols[1], aboutAmount: vCols[5]}] : [], //承运人订单号
                      salesMan: vCols[2],
                      clientName: vCols[3],
                      moneyType: moneyType,
                      clientRegisiterNum: vCols[5],
                      isOrderCompName: false,
                      isOrdersalesMan: false,
                      isOrderClientName: false,
                      payAmount: vCols[6], //付款金额
                      note: vCols[7], //摘要
                      recName: vCols[8], //收款企业（人）名称
                      recCompName: vCols[9], //所属公司
                      recAccount: vCols[10], //收款账号
                      paymentsName: vCols[11], //付款企业（人）名称
                      payCompName: vCols[12],//所属公司
                      payAccount: vCols[13], //收款账号
                    };
                  } else {
                    item = {
                      compName: this.formData.compName,
                      index: vCols[0], //需要
                      ordersList: vCols[1] ? [{ordersNum: vCols[1], aboutAmount: vCols[6]}] : [], //承运人订单号
                      salesMan: vCols[2],
                      clientName: vCols[3],
                      moneyType: moneyType,
                      clientRegisiterNum: vCols[5],
                      isOrderCompName: false,
                      isOrdersalesMan: false,
                      isOrderClientName: false,
                      addTime: getExcelTime(vCols[6]), //收款日期
                      payAmount: vCols[7], //付款金额
                      note: vCols[8], //摘要
                      recName: vCols[9], //收款企业（人）名称
                      recAccount: vCols[10],//收款账号
                      recBank: vCols[11], //收款开户行
                      paymentsName: vCols[12], //付款企业（人）名称
                      payAccount: vCols[13], //付款账号
                      payBank: vCols[14] //付款开户行
                    };
                  }
                  item.platformCompanyId = this.platformCompMap[item.compName];
                  tableData.push(item);
                }
              });
              this.tableData = tableData;
              this.updateFooterEvent();
              setTimeout(() => {
                hideLoading();
              }, 1000);
            };
            fileReader.readAsBinaryString(files[0]);
          });
    },

    async selectCompName(row, id, name) {
      let tableData = this.$refs[this.tableName].getTableData().tableData;
      let hasComp = false;
      tableData.map(i => {
        // 选择平台清空收付款信息
        if (isNotEmpty(i.compName) && i.compName !== name) {
          hasComp = true;
        }
      });
      if (hasComp) {
        let confirmRes = await this.$XModal.confirm("更换所属平台公司将清空关联订单", "是否更换");
        if (confirmRes === "confirm") {
          tableData.map(i => {
            i[this.amountListName] = [];
            i.ordersNum = null;
          })
        } else {
          return;
        }
      }

      if (this.payType === 0) {
        // 自动带数据
        let payRes = await apiRequest("api/finance/", "cebBusiMem/queryMemList", {
          orderBy: 2,
          page: 1,
          rows: 10,
          subjectType: 0,
          memName: name,
        });
        if (payRes.status === 1 && payRes.data.rows && payRes.data.rows.length === 1) {
          tableData.map(i => {
            this.account = payRes.data.rows[0];
            i.recBank = payRes.data.rows[0].busiSubjectName;
            i.recBankOwn = payRes.data.rows[0].busiSubjectName;
            i.recName = payRes.data.rows[0].memName;
            i.recCompName = payRes.data.rows[0].busiSubjectName;
            i.recAccount = payRes.data.rows[0].subAcc;
          });
        } else {
          this.account = {};
          tableData.map(i => {
            i.recBank = null;
            i.recBankOwn = null;
            i.recName = null;
            i.recCompName = null;
            i.recAccount = null;
          });
        }
      }
      this.platformCompanyId = id;
      this.compName = name;
      tableData.map(i => {
        i.platformCompanyId = id;
        i.compName = name;
      });
    },
    async openOrderModal(row) {
      if (this.canInsert) {
        let cate = "Collection";
        this.currentRow = row;
        if (this.payType === 0) {
          // 线上
          if (
              isNotEmpty(row.compName) ||
              this.isInitByOrder == "buyer" ||
              this.fromOrigin === "chain"
          ) {
            this.isShowOnlineChooseOrder = true;
            this.$refs.refPaymentAboutOrderOnline.init(
                this.type,
                cate,
                0,
                row.payAmount,
                row[this.amountListName],
                row.compName,
                row.platformCompanyId,
                'collection'
            );
          } else {
            await this.$refs[this.tableName].clearValidate();
            await this.$refs[this.tableName].validate(row, err => {
            });
          }
        } else {
          // 线下
          if (isNotEmpty(row.payAmount)) {
            if (this.canInsert) {
              // if (isEmpty(row.platformCompanyId)) {
              //   this.$XModal.message({
              //     message: "所属平台公司名称错误"
              //   });
              //   return;
              // }
              this.isShowChooseOrder = true;
              this.$refs.refPaymentAboutOrder.init(
                  "Collection",
                  0,
                  row.payAmount,
                  row[this.amountListName],
                  row.platformCompanyId
              );
            }
          } else {
            await this.$refs[this.tableName].clearValidate();
            await this.$refs[this.tableName].validate(row, err => {
            });
          }
        }
      }
    },
    async chooseOrderOnlineEvent(amountList, usedAmount) {
      this.isShowOnlineChooseOrder = false;
      this.$refs[this.tableName].clearValidate("ordersNum");
      this.currentRow.ordersList = amountList;
      this.currentRow.clientName = amountList[0].buyerName;
      this.currentRow.ordersNum = amountList[0].ordersNum;
      this.currentRow.salesMan = amountList[0].salesMan;
      // 选择订单重置银行信息
      this.currentRow.payBank = null;
      this.currentRow.paymentsName = null;
      this.currentRow.payAccount = null;
      this.currentRow.recBank = null;
      this.currentRow.recName = null;
      this.currentRow.recAccount = null;
      this.currentRow.payCompName = null;
      this.currentRow.recCompName = null;

      // console.log("线上支付自动带入银行账户信息", this.currentRow);
      let path = "api/finance/";
      let action = "cebBusiMem/queryMemList";
      let params = {};
      params.busiSubjectId = amountList[0].platformCompanyId;
      // console.log(this.currentRow, "this.currentRow.ordersBuyerAmountList");
      if (isNotEmpty(this.currentRow.ordersList)) {
        params.subjectId = this.currentRow.ordersList[0].buyerId;
        amountList[0].paymentType = 1;
      }
      switch (amountList[0].paymentType) {
        case 1:
          params.subjectType = 1;
          break;
        case 2:
          params.subjectType = 0;
          break;
        case 3:
          params.subjectType = 1;
      }
      let res = await apiRequest(path, action, params);
      if (res.status === 1) {
        if (res.data.rows.length < 1) {
          this.$XModal.message({
            message: "付款企业或者个人未绑定子账户，请先绑定子账户"
          });
          return;
        } else {
          let arr = res.data.rows.filter(item => {
            return item.busiSubjectName == this.currentRow.compName;
          });
          this.currentRow.payBank = "光大银行";
          this.currentRow.paymentsName = arr[0].memName;
          this.currentRow.payCompName = arr[0].busiSubjectName;
          this.currentRow.payAccount = arr[0].subAcc;
        }
      }

      if (isNotEmpty(this.currentRow.ordersList)) {
        params.subjectId = amountList[0].platformCompanyId;
        amountList[0].paymentType = 1;
      }
      switch (amountList[0].paymentType) {
        case 1:
          params.subjectType = 0;
          break;
        case 2:
          params.subjectType = 1;
          break;
        case 3:
          params.subjectType = 1;
      }
      let redRes = await apiRequest(path, action, params);
      if (redRes.status === 1) {
        if (redRes.data.rows.length < 1) {
          this.$XModal.message({
            message: "收款企业或者个人未绑定子账户，请先绑定子账户"
          });
          return;
        } else {
          let arr = redRes.data.rows.filter(item => {
            return item.busiSubjectName == this.currentRow.compName;
          });
          this.currentRow.recBank = "光大银行";
          this.currentRow.recName = arr[0].memName;
          this.currentRow.recAccount = arr[0].subAcc;
          this.currentRow.recCompName = arr[0].busiSubjectName;
        }
      }
    },
    openChooseAccount(row, field) {
      this.isShowChooseAccount = true;
      this.currentRow = row;
      this.currentChooseColumn = field;
      this.$refs.chooseAccount.init();
    },
    async chooseAccountEvent(account, type) {
      this.currentRow[this.currentChooseColumn] = account.userName;
      if (type !== 0) {
        this.currentRow.clientId = account.id;
      }

      this.isShowChooseAccount = false;
      this.$refs[this.tableName].clearValidate(this.currentChooseColumn);

      if (this.payType === 0) {
        // 自动带数据
        let params = {
          orderBy: 2,
          page: 1,
          rows: 10,
        };
        if (type !== 0) {
          params.subjectType = 1;
          params.subjectId = account.id;
          params.busiSubjectId = this.platformCompanyId;
        } else {
          params.subjectType = 0;
          params.memName = account.name;
        }
        let payRes = await apiRequest("api/finance/", "cebBusiMem/queryMemList", params);
        if (
            payRes.status === 1 &&
            payRes.data.rows &&
            payRes.data.rows.length === 1) {
          this.currentRow.payBank = payRes.data.rows[0].busiSubjectName;
          this.currentRow.payBankOwn = payRes.data.rows[0].busiSubjectName;
          this.currentRow.paymentsName = payRes.data.rows[0].memName;
          this.currentRow.payCompName = payRes.data.rows[0].busiSubjectName;
          this.currentRow.payAccount = payRes.data.rows[0].subAcc;
        } else {
          this.currentRow.payBank = null;
          this.currentRow.payBankOwn = null;
          this.currentRow.paymentsName = null;
          this.currentRow.payAccount = null;
          this.currentRow.payCompName = null;
        }
      }
    },
    chooseOrderEvent(amountList, usedAmount) {
      // console.log("chooseOrderEvent", amountList, usedAmount);
      this.isShowChooseOrder = false;
      this.$refs[this.tableName].clearValidate("ordersNum");

      //关联订单数据
      this.currentRow.usedAmount = usedAmount;
      this.currentRow.ordersList = amountList;
      if (amountList.length > 0) {
        this.currentRow.ordersNum = amountList[0].ordersNum;
        this.currentRow.clientName = amountList[0].buyerName;
        this.currentRow.clientId = amountList[0].buyerId;
        this.currentRow.salesMan = amountList[0].salesMan;
        // this.currentRow.salesManId = amountList[0].salesManId;
      } else {
        this.currentRow.ordersNum = "";
      }
    },
    removeOrder(row) {
      this.$set(row, 'ordersList', []);
    },
    openBankAccountModal(row, field, accountCate, index) {
      if (isEmpty(this.formData.compName)) {
        this.$XModal.message({status: "error", message: "请先选择所属公司"});
        return
      }
      if (field === 'paymentsName' && isEmpty(row.clientName)) {
        this.$XModal.message({status: "error", message: "请先选择客户名称"});
        return
      }
      this.currentRow = row;
      this.currentChooseColumn = field;
      if (this.payType === 1) {
        this.isShowBankAccountModal = true;
        this.bankAccountModalTitle =
            accountCate == "platform" ? "选择平台银行账户" : "选择用户银行账户";
        this.$refs.bankAccountModal.init(accountCate, field, row);
      } else {
        let curfield = field === "paymentsName" ? "recName" : "paymentsName";
        let compNameType = 0;
        this.isShowFinance = true;
        this.$refs.financeAccount.init(row, index, curfield, compNameType, null, 'collection');
      }
    },
    chooseFinanceAccount(account, index, field) {
      this.isShowFinance = false;
      let tableData = this.$refs[this.tableName].getTableData().fullData;

      if (tableData[index]) {
        if (field == "paymentsName") {
          tableData[index].recBank = "光大银行";
          tableData[index].recName = account.memName;
          tableData[index].recAccount = account.subAcc;
          tableData[index].recCompName = account.busiSubjectName;
        } else {
          // 清空数据
          tableData[index].payBank = "光大银行";
          tableData[index].paymentsName = account.memName;
          tableData[index].payAccount = account.subAcc;
          tableData[index].payCompName = account.busiSubjectName;
        }
      }
    },
    chooseBankAccount(bankAccount) {
      if (this.currentChooseColumn == "paymentsName") {
        this.currentRow.payBank = bankAccount.openBankName;
        this.currentRow.paymentsName = bankAccount.accountName;
        this.currentRow.payAccount = bankAccount.accountNum;
      } else {
        this.currentRow.recBank = bankAccount.bankName;
        this.currentRow.recName = bankAccount.accountName;
        this.currentRow.recAccount = bankAccount.accountNum;
      }
      this.isShowBankAccountModal = false;
      this.$refs[this.tableName].clearValidate(this.currentChooseColumn);
    },
    closeBankAccount() {
      // console.log("closeBankAccount");
      this.isShowBankAccountModal = false;
    },
    inputPayAmountEvent(row) {
      if (isNotEmpty(row.payAmount) && row.ordersNum == " ") {
        row.ordersNum = null;
      }
      //从订单进入创建,  没有关联金额, 输入付款金额保存到关联金额
      if (!this.canInsert && isNotEmpty(row.payAmount)) {
        row[this.amountListName][0].aboutAmount = row.payAmount;
      }
      this.$refs[this.tableName].clearValidate("payAmount");
      this.updateFooterEvent();
    },
    async validEvent() {
      const errMap = await this.$refs[this.tableName].validate().catch(errMap => errMap);
      return errMap ? false : true;
    },
    uploadFile() {
      alert("上传附件");
    },
    async submitEvent(type = "new") {
      this.isSubmit = true;
      let table = this.$refs[this.tableName].getTableData();
      let errMsgRow = "";
      let isErr = false;
      let isSameCompMsgRow = "";
      let isSameCompErr = false;

      this.$refs[this.tableName].updateStatus();
      if (type === 'new') {
        if (isEmpty(this.formData.compName)) {
          this.$XModal.message({status: "error", message: "请先选择所属公司"});
          return
        }

        if (isEmpty(this.formData.isQqPush)) {
          this.$XModal.message({status: "error", message: "请选择同步企企"});
          return
        }

        let sts = await this.validEvent();
        if (!sts) {
          this.$XModal.message({
            status: "error",
            message: "校验不通过！"
          });
          return;
        }

        if (table.tableData.length == 0) {
          this.$XModal.message({
            message: "请先添收付款"
          });
          return;
        }

        table.fullData.forEach((item, index) => {
          if (item.payAccount == item.recAccount) {
            isErr = true;
            errMsgRow = `${index + 1},`;
          }
          if (item.payCompName != item.recCompName) {
            isSameCompErr = true;
            isSameCompMsgRow = `${index + 1},`;
          }
        });
        if (isErr && this.payType === 0) {
          this.$XModal.message({
            message: `序号${errMsgRow}付款人与收款人子账户不能一致`
          });
          return;
        }
        if (isSameCompErr && this.payType === 0) {
          this.$XModal.message({
            message: `序号${isSameCompMsgRow}付款人与收款人所属公司不一致`
          });
          return;
        }
      }


      if (this.payType === 0) {
        let map = {};
        let check = false;

        table.fullData.some(i => {
          if (map[i.clientName]) {
            let value = map[i.clientName];
            if (value.clientName === i.clientName && value.payAmount === i.payAmount) {
              this.$XModal.message({
                message: '同一客户存在相同金额，请分开提交流程',
              });
              check = true;
              return true;
            }
          } else {
            map[i.clientName] = i;
          }
        })

        if (check) return;
      }


      let rows = [];
      let outParamsObj = {};
      if (this.payType === 1) {
        table.fullData.forEach(item => {
          let row = {};
          row.addTime = item.addTime ? this.$utils.timestamp(
              this.$utils.toStringDate(item.addTime)
          ) : null;
          row.clientName = item.clientName;
          row.clientId = item.clientId;
          row.compName = item.compName;
          row.fileUuidList = item.fileUuidList;
          row.note = item.note;
          let ordersAmountList = [];
          let usedAmount = 0;
          if (item.ordersList && item.ordersList.length > 0) {
            item.ordersList.forEach(item => {
              let obj = {
                aboutAmount: item.aboutAmount,
                ordersNum: item.ordersNum
              };
              ordersAmountList.push(obj);
              usedAmount += item.aboutAmount;
            });
          }

          row.ordersAmountList = ordersAmountList;
          row.payAccount = item.payAccount;
          row.payAmount = item.payAmount;
          row.payBank = item.payBank;
          row.payBankCode = item.payBankCode;
          row.paymentsName = item.paymentsName;
          row.paymentType = 1; //类型:1-应收,2-应付
          row.platformCompanyId = item.platformCompanyId;
          row.clientRegisiterNum = item.clientRegisiterNum;
          row.recAccount = item.recAccount;
          row.recBank = item.recBank;
          row.recName = item.recName;
          row.salesMan = item.salesMan;
          row.usedAmount = item.ordersList && item.ordersList.length > 0 ? usedAmount : 0;
          row.unusedAmount = parseFloat(row.payAmount) - row.usedAmount;
          row.moneyType = item.moneyType;
          if (this.isAcc) {
            row.tradeDetailId = this.accData.id;
          }
          rows.push(row);
        });
        outParamsObj.paymentList = rows;
        outParamsObj.payType = 0; // 线下
        outParamsObj.isQqPush = this.formData.isQqPush;
      } else {
        // 线上支付  参数重传
        let onlineRows = {};
        onlineRows.detailList = [];
        table.fullData.forEach(item => {
          let paramesObj = {};
          paramesObj.paymentType = 1; // 付款2 收款1
          paramesObj.clientName = item.clientName;
          paramesObj.clientId = item.clientId;
          paramesObj.compName = item.compName;
          paramesObj.ownName = item.compName;
          paramesObj.note = item.note;
          paramesObj.payAccount = item.payAccount;
          paramesObj.payAmount = item.payAmount;
          paramesObj.paymentsName = item.paymentsName;
          paramesObj.payBankOwn = item.payCompName;
          paramesObj.platformCompanyId = item.platformCompanyId;
          paramesObj.clientRegisiterNum = item.clientRegisiterNum;
          paramesObj.recAccount = item.recAccount;
          paramesObj.recName = item.recName;
          paramesObj.recBankOwn = item.recCompName;
          paramesObj.salesMan = item.salesMan;
          paramesObj.salesManId = item.salesManId;
          paramesObj.fileUuidList = item.fileUuidList;
          paramesObj.rateManage = item.rateManage;
          paramesObj.isDraw = item.isDraw;
          paramesObj.drawBank = item.drawBank;
          paramesObj.drawAccount = item.drawAccount;
          paramesObj.moneyType = item.moneyType;
          paramesObj.ordersList = [];
          if (item.ordersList && item.ordersList.length > 0) {
            item.ordersList.forEach(i => {
              let inObj = {
                ordersNum: i.ordersNum,
                aboutAmount: item.payAmount
              };
              paramesObj.ordersList.push(inObj);
            });
          }

          onlineRows.detailList.push(paramesObj);
        });
        outParamsObj.onlinePaymentVo = onlineRows;
        outParamsObj.payType = 1; // 1线上
      }

      showLoading();
      let that = this;
      setTimeout(() => {
        // if (!this.isErrMap) {
        //   this.$XModal.message({
        //     status: "error",
        //     message: "校验不通过！"
        //   });
        //   hideLoading();
        //   return;
        // }
        let uploadtable = this.uploadData;
        outParamsObj.attachFile = uploadtable[0].fileUuidList;
        outParamsObj.applyTime = this.$utils.timestamp(
            this.$utils.toStringDate(this.formData.applyTime)
        );
        outParamsObj.instanceName = this.formData.instanceName;
        outParamsObj.instanceNum = this.formData.instanceNum;
        outParamsObj.applyUserId = this.formData.applyUserId;
        outParamsObj.leaderId = this.formData.leaderId;
        outParamsObj.managerId = this.formData.managerId;
        outParamsObj.reterenceId = this.formData.reterenceId;
        outParamsObj.reterenceName = this.formData.reterence;
        outParamsObj.flowTempletId = this.flowTempletId;
        outParamsObj.isQqPush = this.formData.isQqPush;
        if (this.isInitBySave) {
          outParamsObj.id = this.initBySaveId;
        }
        if (this.payType === 1) {
          // 线下不变
          if (type === "new") {
            $api.flowInstance.saveFlowForPaymentBuyerTwo
                .POST({
                  data: outParamsObj
                })
                .then(res => {
                  hideLoading();
                  if (res.status === 1) {
                    this.$XModal.message({
                      status: "success",
                      message: "提交成功"
                    });
                    this.tableData = [];
                    this.$emit("close");
                    window.close();
                  } else if (res.status == 0) {
                    showFailMsgList(res.data);
                  } else {
                    that.$XModal.alert({
                      message: res.message ? res.message : "接口异常",
                      status: "error"
                    });
                  }
                });
          } else {
            $api.flowInstance.saveDraftFlowForPaymentBuyerTwo
                .POST({
                  data: outParamsObj
                })
                .then(res => {
                  hideLoading();
                  if (res.status === 1) {
                    this.$XModal.message({
                      status: "success",
                      message: "保存成功"
                    });
                    this.tableData = [];
                    this.$emit("close");
                    window.close();
                  } else if (res.status == 0) {
                    showFailMsgList(res.data);
                  } else {
                    that.$XModal.alert({
                      message: res.message ? res.message : "接口异常",
                      status: "error"
                    });
                  }
                });
          }
        } else {
          if (type === "new") {
            $api.flowInstance.saveFlowForPaymentSellerTwo
                .POST({
                  data: outParamsObj
                })
                .then(res => {
                  hideLoading();
                  if (res.status === 1) {
                    let mesTxt =
                        this.payType === 1 ? "提交成功" : "提交成功，待银行处理";
                    this.$XModal.message({
                      status: "success",
                      message: mesTxt
                    });
                    this.tableData = [];
                    this.$emit("close");
                    window.close();
                  } else if (res.status == 0) {
                    showFailMsgList(res.data);
                  } else {
                    that.$XModal.alert({
                      message: res.message ? res.message : "接口异常",
                      status: "error"
                    });
                  }
                });
          } else {
            $api.flowInstance.saveDraftFlowForPaymentSellerTwo
                .POST({
                  data: outParamsObj
                })
                .then(res => {
                  hideLoading();
                  if (res.status === 1) {
                    this.$XModal.message({
                      status: "success",
                      message: "保存成功"
                    });
                    this.tableData = [];
                    this.$emit("close");
                    window.close();
                  } else if (res.status == 0) {
                    showFailMsgList(res.data);
                  } else {
                    that.$XModal.alert({
                      message: res.message ? res.message : "接口异常",
                      status: "error"
                    });
                  }
                });
          }
        }
        this.$emit("init");
      }, 100);
    },
    footerCellClassName({$rowIndex, column, columnIndex}) {
      return "footer-cell";
    },
    footerMethod({columns, data}) {
      return paymentFooter({
        columns,
        data,
        rowName: "合计"
      });
    },
    updateFooterEvent() {
      this.$refs[this.tableName].updateFooter();
    },
    async initPlatCompMap() {
      if (isEmpty(this.platformCompMap)) {
        let res = await $api.department.get("listCompany");
        let map = {};
        res.data.rows.forEach(item => {
          map[item.name] = item.id;
        });
        this.platformCompMap = map;
      }
    }
  }
};
</script>
<style>
.window {
  padding: 20px;
  background: #ffffff;
  height: 100vh;
  position: relative;
}

.my-dropdown4 {
  width: 600px;
  height: 300px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.1);
}

.link-text {
  color: #2d8cf0;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
}

.placeholder {
  color: #ddd;
  font-size: 12px;
  line-height: 100%;
  vertical-align: middle;
}

.pay-modal-main {
  padding-top: 20px;
}

table .vxe-input--extra-suffix {
  /* display: none !important; */
}
</style>
<style scoped>
.add-box .produre .vxe-input, .add-box .produre .vxe-select, .add-box .produre .ivu-cascader .ivu-input {
  height: 30px;
}

.produre .vxe-select >>> .vxe-input {
  height: 30px;
}

.produre >>> .vxe-body--column {
  height: 30px !important;
}

.produre >>> .vxe-body--column:not(.col--ellipsis), .produre >>> .vxe-footer--column:not(.col--ellipsis), .produre >>> .vxe-header--column:not(.col--ellipsis) {
  padding: 3px 0;
}


.footer-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  overflow: hidden;
  vertical-align: middle;
  background-color: #fff;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 15px;
  display: flex;
  justify-content: flex-end;
}

.left10 {
  margin-left: 10px;
}
</style>

